module.exports = __webpack_public_path__ + "static/media/google.7c515d5d.svg";